'use strict';

import config from './config/config';
import {NewsletterPopup} from './flyins/newsletterpopup';
const tabletDesktopMQ = window.matchMedia(`(min-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);
var $ = require('jquery');
require('./utils/jquery-extensions');

var commonModules = require('./components/common');
var countries = require('./components/country-selection/countries');
var minicart = require('./components/header/minicart');
var wishlist = require('./pages/wishlist');
var miniwishlist = require('./components/header/miniwishlist');
var flyin = require('./flyins/flyin');
var flyinscrolling = require('./flyins/flyinscrolling');
var searchinputfield = require('./search/searchinputfield');
var inputfields = require('./utils/inputfields');
var scrolledpage = require('./components/scrolledpage');
var smoothscrolling = require('./utils/smoothscrolling');
var validator = require('./utils/validator');
var carousel = require('./components/carousel');
var legalterms = require('./components/legalterms');
var newsletterfooter = require('./components/footer/newsletterfooter');
var footbed = require('./footbed/footbed');
var pdpsize = require('./components/product/pdpsize');
var showpassword = require('./utils/showpassword');
var videovimeo = require('./utils/videovimeo');
var emojiremove = require('./utils/emojiremove');
var lazyload = require('./utils/lazyload');
var distributionmodules = require('./components/distributionmodules');
var producthintwidth = require('./components/product/producthintwidth'); // Product Hint Width
var pageProduct = require('./pages/product');
var productTabs = require('./components/product/product-tabs');
var stickyAddToBag = require('./productdetail/sticky-add-to-bag');
var crossSell = require('./components/cross-sell');
var variationCarousel = require('./productdetail/variation-carousel');
var stickyPanel = require('./productdetail/sticky-panel');
var cartoverlay = require('./components/checkout/cartoverlay');
var breadcrumbs = require('./components/breadcrumbs');
var flyinstorelocator = require('./productdetail/flyin-storelocator');
var afterpayMessaging = require('./components/product/afterpayMessaging');
const footbedmodule = require('./footbed/footbed-module');
const wannaAugmentedReality = require('./productdetail/wannaAugmentedReality');
const privacyOverlay = require('./components/privacy-overlay');
const fitPredictor = require('./components/fit-predictor');
const klaviyoListeners = require('./klaviyo/klaviyoListeners');
import webVitals from './components/web-vitals';
import {initUniversalRecommendations} from './constructor-io/helpers/recommendations';

// initialize app
$(function () {
    commonModules.initializeDom();
    commonModules.initializeEvents();
    commonModules.init();
    commonModules.initCookiePrivacy();

    // init specific global components
    breadcrumbs.init();
    emojiremove.init();
    lazyload.init();
    countries.init();
    scrolledpage.init('pdp');
    smoothscrolling.init();
    flyinscrolling.init();
    inputfields.init();
    minicart.init();
    miniwishlist.init();
    flyin.init();
    searchinputfield.init();
    validator.init();
    carousel.init();
    newsletterfooter.init();
    footbed.init();
    pdpsize.init();
    showpassword.init();
    distributionmodules.init();
    legalterms.init();
    producthintwidth.init();
    commonModules.changeMainWrapperPadding();
    cartoverlay.init();
    flyinstorelocator.init();
    wannaAugmentedReality.init();
    afterpayMessaging.init();
    NewsletterPopup.initCLPandPDP();
    webVitals.init();
    klaviyoListeners.init();

    // add product tabs functionality
    productTabs.init();

    // execute page specific initializations
    pageProduct.init();
    variationCarousel.init();
    stickyAddToBag.init();
    stickyPanel.init();

    // render the fit predictor and set the product context
    fitPredictor.setProduct();
    fitPredictor.start();

    // initialize vimeo video for tablets and desktop
    if (tabletDesktopMQ.matches) {
        videovimeo.init();
    }

    if ($('.footbed-module').length > 0) {
        footbedmodule.init();
    }

    initUniversalRecommendations('product');

    // show cookies popup
    $('body').on('click', '.disallowed-cookie--accept', function () {
        $('body').addClass('ui-dialog-position-fixed');
        privacyOverlay.initPrivacyOverlay().open();
    });

    // needed for Demandware Predictive Recommendations
    window.dwapp = {
        reportRecommendationLoad: function () {
            lazyload.init();
            wishlist.init();
            carousel.init();
            crossSell.init();
        },

        reportCartRecommendationLoad: function () {
            var is1774 = $('.landing-1774').length > 0;
            lazyload.init();
            if (is1774) {
                carousel.init();
            } else {
                cartoverlay.slickRecomm();
            }
            crossSell.init();
        }
    };
});
